import styled from 'styled-components';
import { brandColors } from 'styles/colors';
import { breakpoint, font } from 'styles/globals';
import { getColor, Theme } from 'styles/theme';

export const Wrapper = styled.div<{ theme: Theme }>`
  background-color: ${getColor('surfaceWhite')};
  border-left: 3px solid ${brandColors.own.surfaceBrand};
  font-family: ${font.graphikCompact};
  margin: -26px 16px 0 13px;
  position: relative;
  width: fit-content;

  @media (${breakpoint.mdMin}) {
    border-left: 4px solid ${brandColors.own.surfaceBrand};
    margin: -24px 24px 0 20px;
  }

  @media (${breakpoint.xlMin}) {
    margin: -60px 48px 0 0;
  }
`;

export const List = styled.ul<{ theme: Theme }>`
  display: flex;
  flex-wrap: wrap;
  padding: 16px 16px 0 8px;
  position: relative;

  @media (${breakpoint.mdMin}) {
    flex-direction: row;
    padding: 24px 24px 0 16px;
  }

  &::before {
    background: ${getColor('surfaceWhite')};
    bottom: 10px;
    content: '';
    height: 10px;
    left: 0;
    position: absolute;
    width: 100%;
    z-index: 5;
  }

  &::after {
    background: ${getColor('surfaceWhite')};
    content: '';
    height: 100%;
    position: absolute;
    right: 9px;
    top: 0;
    width: 8px;

    @media (${breakpoint.mdMin}) {
      width: 16px;
    }

    @media (${breakpoint.xlMin}) {
      width: 24px;
    }
  }
`;

export const ItemList = styled.li<{ theme: Theme }>`
  border-bottom: 1px solid ${getColor('borderSecondary')};
  border-right: 1px solid ${getColor('borderSecondary')};
  flex: 1;
  margin: 0 0 16px 0;
  padding: 0 16px 16px 8px;
  position: relative;
  list-style: none;

  @media (${breakpoint.xlMin}) {
    flex: none;
    padding: 0 16px 16px 16px;
  }

  &::before {
    background: ${getColor('surfaceWhite')};
    bottom: 0;
    content: '';
    height: 16px;
    position: absolute;
    right: -2px;
    width: 4px;
  }
`;

export const Heading = styled.div<{ theme: Theme }>`
  color: ${getColor('textSecondary')};
  font-family: ${font.graphikCond};
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 1px;
  line-height: 18px;
  margin-bottom: 8px;
  text-align: left;
  text-transform: uppercase;
  white-space: nowrap;
  word-wrap: nowrap;
`;

export const Data = styled.div`
  font-family: ${font.graphikCond};
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0.15px;
  line-height: 24px;
  text-align: left;
`;
